// extracted by mini-css-extract-plugin
export default {"appNormal":"RootLayout_appNormal__uq3kt"};